import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';

export const GET_WHD_BULK_UPLOADS_REQUEST = 'GET_WHD_BULK_UPLOADS_REQUEST';
export const GET_WHD_BULK_UPLOADS_SUCCESS = 'GET_WHD_BULK_UPLOADS_SUCCESS';
export const GET_WHD_BULK_UPLOADS_FAILURE = 'GET_WHD_BULK_UPLOADS_FAILURE';

function requestGetWhdBulkUploads() {
  return {
    type: GET_WHD_BULK_UPLOADS_REQUEST,
    isGettingBulkUploads: true
  };
}

function receiveGetWhdBulkUploads(bulkUploads, bulkUploadCount, gridTotalLimit) {
  return {
    type: GET_WHD_BULK_UPLOADS_SUCCESS,
    isGettingBulkUploads: false,
    bulkUploads,
    bulkUploadCount,
    gridTotalLimit
  };
}

function rejectGetWhdBulkUploads() {
  return {
    type: GET_WHD_BULK_UPLOADS_FAILURE,
    isGettingBulkUploads: false
  };
}

export function getWhdBulkUploads(pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, accountId) {
  return (dispatch) => {
    dispatch(requestGetWhdBulkUploads());
    const promise = () => ApiService
      .getWhdBulkUploads(pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, accountId)
      .then((response) => {
        dispatch(receiveGetWhdBulkUploads(response.data.items, response.data.totalCount, response.data.totalLimit));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetWhdBulkUploads, true));
        }
      });
    return promise();
  };
}

export function getWhdBulkUploadsByObject(requestObject) {
  return getWhdBulkUploads(
    requestObject.pageNumber,
    requestObject.pageSize,
    requestObject.totalLimit,
    requestObject.sortByField,
    requestObject.sortDirection,
    requestObject.filterList,
    requestObject.accountId,
  );
}
